module.exports = __webpack_public_path__ + "static/media/strenght.5aac75c3.png";